import times from 'lodash/times';
import React from 'react';
import { PDFSafeTableHeaderCaption } from '../../../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';
import { HtmlTable } from '../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';
import { ColumnHeader } from '../../OtherAssets.meta';

export interface Props {
  title: string;
  isEmpty: boolean;
  columnHeaders: ColumnHeader[];
  children: React.ReactNode;
  workflowProps?: WorkflowComponentProps;
}

export const AssetsTable = ({
  title,
  isEmpty,
  columnHeaders,
  children,
  workflowProps,
  ...rest
}: Props) => {
  return (
    <HtmlTable variant={workflowProps && 'bordered'} {...rest}>
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          {times(columnHeaders.length).map(key => (
            <col key={key} />
          ))}

          <col style={{ width: 126 }} />
        </colgroup>

        <thead>
          <PDFSafeTableHeaderCaption colSpan={columnHeaders.length + 1}>
            {title}
          </PDFSafeTableHeaderCaption>

          {!isEmpty && (
            <tr>
              {columnHeaders.map(({ text, align }) => (
                <th key={text}>
                  <Text
                    variant="smallCaps"
                    textAlign={align || 'left'}
                    style={{ whiteSpace: 'normal' }}
                  >
                    {text}
                  </Text>
                </th>
              ))}

              <th aria-label={`${title} Actions`}>&nbsp;</th>
            </tr>
          )}
        </thead>

        <tbody>
          {isEmpty ? (
            <tr>
              <td colSpan={columnHeaders.length + 1}>
                <Text fontWeight={500} color="neutral.500">
                  You have not added any items.
                </Text>
              </td>
            </tr>
          ) : (
            children
          )}
        </tbody>
      </table>
    </HtmlTable>
  );
};
